import React from 'react';

const VerificationModal = ({ isActive, imageUrl }) => {
  if (!isActive) return null;

  return (
    <div className="image-modal">
      <div className="image-modal-content">
        <img src={imageUrl} alt="Verification" />
      </div>
    </div>
  );
};

export default VerificationModal;